// Переключатель дизайна: classic (по умолчанию) / cp. Старая версия — ZoneInfo.styled.classic.js, новая — ZoneInfo.styled.cp.js
import { isCp } from 'libs/design';
import * as classic from './ZoneInfo.styled.classic';
import * as cp from './ZoneInfo.styled.cp';

export const Content = isCp ? cp.Content : classic.Content;
export const Display = isCp ? cp.Display : undefined;
export const Number = isCp ? cp.Number : classic.Number;
